import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { NoteComposer, NoteList } from "@/features/notes";

export const Route = createFileRoute("/_app/")({
  component: NotesScreen,
});

function NotesScreen() {
  const { t } = useTranslation("notes");

  // No effect, no manual load: the query fetches on mount, de-duplicates across screens,
  // serves a cached first paint on the way back, and refetches when the app is foregrounded.
  return (
    <div className="flex flex-col gap-7">
      <h1 className="text-title">{t("title")}</h1>
      <NoteComposer />
      <NoteList />
    </div>
  );
}
